$(document).ready(function () 
{

    if ($(".teletype").length)
    {

        $(".teletype").each( function(i)
        {
            var el = $(this),
                text = el.text(),
                speed = 100, 
                initial_height = el.height(),
                initial_width = el.width(),
                wordArray = []
                i = 1;
            
            text = text.trim();

            el.width(initial_width);
            el.height(initial_height);

            //var wordArray = text.split(' '), i = 1;


            for (var j = 0; j < text.length; j++) 
            {
                wordArray.push(text.charAt(j));
            }
            //console.log(wordArray);

            if (wordArray.length > 2)
            {
                el.empty();
                //el.append(wordArray[0] + ' ');
                el.append(wordArray[0]);
                INV = setInterval(function () 
                {
                    if (i >= wordArray.length - 1) {
                        clearInterval(INV);
                    }
                    //el.append(wordArray[i] + ' ');
                    el.append(wordArray[i]);

                    i++;
                    if (i == wordArray.length)
                    {
                        $(".after-teletype").addClass('show');
                    }

                }, speed);

            };

        });

    }
});